/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Iframe_Remote_Subtitle_Import_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to import subtitle file: {error}" |
*
* @param {Iframe_Remote_Subtitle_Import_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_subtitle_import_failed_toast = /** @type {((inputs: Iframe_Remote_Subtitle_Import_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Subtitle_Import_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de l'import du fichier de sous-titres : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Untertiteldatei konnte nicht importiert werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile importare il file dei sottotitoli: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось импортировать файл субтитров: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al importar el archivo de subtítulos: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导入字幕文件失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`字幕ファイルのインポートに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`उपशीर्षक फ़ाइल आयात करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao importar o arquivo de legenda: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to import subtitle file: ${i?.error}`)
});